export default () => ({
  video: false,
  title: false,
  card: false,
  useStill: false,
  hasVideo: false,
  stalledTimer: null,

  init() {
    this.hasVideo = !!this.$refs.video;

    // 1. Explicit user preference: reduce motion
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.useStill = true;
      return;
    }

    // 2. Save-Data header / low-bandwidth mode
    const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (conn) {
      if (conn.saveData) {
        this.useStill = true;
        return;
      }
      if (typeof conn.effectiveType === 'string' && /(^|-)(2g|slow-2g)$/i.test(conn.effectiveType)) {
        this.useStill = true;
        return;
      }
    }

    // 3. Battery: low + discharging
    if (typeof navigator.getBattery === 'function') {
      navigator.getBattery().then((battery) => {
        if (!battery.charging && battery.level < 0.2) {
          this.useStill = true;
        }
      }).catch(() => {});
    }

    // 4. Autoplay probe: iOS Low Power Mode blocks autoplay silently — the play() promise
    //    rejects within a frame or two, letting us swap to the still immediately instead
    //    of waiting for a watchdog to fire.
    if (this.hasVideo) {
      const v = this.$refs.video;
      const swap = () => { this.useStill = true; };
      const kickoff = () => clearTimeout(this.stalledTimer);
      v.addEventListener('playing', kickoff, { once: true });
      v.addEventListener('loadeddata', kickoff, { once: true });
      const attempt = v.play();
      if (attempt && typeof attempt.catch === 'function') {
        attempt.catch(swap);
      }
      // Belt-and-braces watchdog for cases where play() resolves but the video never
      // actually paints a frame (some rare mobile browsers).
      this.stalledTimer = setTimeout(() => {
        if (v.readyState < 2 || v.paused) swap();
      }, 1200);
    }
  },

  stalledCheck() {
    if (!this.$refs.video) return;
    if (this.$refs.video.readyState < 2) this.useStill = true;
  },
});
